import {FormGroup} from '@angular/forms';
import {Remuneration} from '@tj/tj-dmp-lib-api';

export type RemunerationTransactionType = 'command' | 'lead';

/** Convert the editable provider/product groups into the flat API representation. */
export function configurationRemunerations(
    groups: any[], transactionType: RemunerationTransactionType = 'command'
): Remuneration[] {
    const result: Remuneration[] = [];
    for (const group of groups || []) {
        for (const product of group.products || []) {
            const append = (value: any, isDefault: boolean) => {
                if (!value) { return; }
                const raw = value instanceof FormGroup ? value.getRawValue() : value;
                const {
                    flightDepartureGeoMode, flightArrivalGeoMode,
                    flightDepartureCity, flightDepartureAirport, flightArrivalCity, flightArrivalAirport,
                    ...persisted
                } = raw;
                const strings = (values: unknown, legacy?: string): string[] =>
                    Array.from(new Set((Array.isArray(values) ? values : legacy ? [legacy] : [])
                        .filter(v => typeof v === 'string' && v.trim()).map(v => v.trim())));
                // Send calendar dates at UTC midnight so a local date picker does not shift the billed day.
                const calendarDate = (value: Date | string | null | undefined): Date | undefined => {
                    if (!value) { return undefined; }
                    const date = value instanceof Date ? value : new Date(value);
                    if (Number.isNaN(date.getTime())) { return undefined; }
                    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                };
                result.push({
                    ...persisted, provider: group.provider, productType: product.productType,
                    typeTransaction: transactionType,
                    defaultRemuneration: isDefault,
                    startDate: isDefault ? undefined : calendarDate(raw.startDate),
                    endDate: isDefault ? undefined : calendarDate(raw.endDate),
                    paymentMethod: isDefault || transactionType === 'lead' ? undefined : raw.paymentMethod || undefined,
                    flightMarketingCarriers: strings(raw.flightMarketingCarriers),
                    flightDepartureCities: strings(raw.flightDepartureCities, flightDepartureCity),
                    flightDepartureCountries: strings(raw.flightDepartureCountries),
                    flightDepartureAirports: strings(raw.flightDepartureAirports, flightDepartureAirport),
                    flightArrivalCities: strings(raw.flightArrivalCities, flightArrivalCity),
                    flightArrivalCountries: strings(raw.flightArrivalCountries),
                    flightArrivalAirports: strings(raw.flightArrivalAirports, flightArrivalAirport)
                });
            };
            append(product.defaultRemuneration, true);
            for (const override of product.overrides || []) {
                append(override?.remuneration ?? override, false);
            }
        }
    }
    return result;
}
